import { render, staticRenderFns } from "./parking_space.vue?vue&type=template&id=50a103ca"
import script from "./parking_space.vue?vue&type=script&lang=js"
export * from "./parking_space.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports